"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var graph_ql_1 = require("../../types/graph-ql");
var dayjs_1 = __importDefault(require("dayjs"));
var ramda_1 = require("ramda");
var constants_1 = require("./constants");
var api_1 = require("../../utils/api");
var reducers = {
    parentalSettings: api_1.createCustomModuleReducer(__assign(__assign(__assign(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_USER_PARENTAL_SETTINGS,
        onSuccess: function (draftState, action) {
            var _a, _b;
            draftState.data = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.parentalSettings;
        },
    })), api_1.createApiReducer({
        actionType: constants_1.SET_PARENTAL_PIN,
        onFailure: function (draftState, action) {
            draftState.error = action.payload;
        },
        onSuccess: function (draftState, action) {
            var _a;
            draftState.data.parentalControl = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.setParentalPin;
        },
    })), api_1.createApiReducer({
        actionType: constants_1.SET_PARENTAL_CONTROLS,
        onFailure: function (draftState, action) {
            draftState.error = action.payload;
        },
        onSuccess: function (draftState, action) {
            var _a;
            draftState.data.parentalControl = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.setParentalControl;
        },
    })), api_1.createApiReducer({
        actionType: constants_1.SET_PARENTALLY_APPROVED_CLASSIFICATION,
        onSuccess: function (draftState, action) {
            var code = action.meta.code;
            draftState.data.approvedClassification = code;
        },
    })), api_1.createApiReducer({
        actionType: constants_1.SET_PIN_VALIDATION_STATUS,
        onSuccess: function (draftState, action) {
            var status = action.meta.status;
            draftState.data.pinValidationStatus = status;
        },
    })), api_1.createApiInitialState({
        parentalControlEnabled: false,
        parentalControl: graph_ql_1.ParentalControl.Disabled,
        approvedClassification: graph_ql_1.NzBsaClassification.G,
    })),
    parentalPinValidation: api_1.createCustomModuleReducer(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.VALIDATE_PARENTAL_PIN,
        onSuccess: function (draftState, action) {
            var _a;
            var _b = action.meta, userProfileId = _b.userProfileId, lastEnteredPin = _b.lastEnteredPin;
            draftState.data[userProfileId] = {
                pinValidationResult: (_a = action.payload) === null || _a === void 0 ? void 0 : _a.validateParentalPin,
                expiryDate: dayjs_1.default().add(10, 'minute'),
                lastEnteredPin: lastEnteredPin,
            };
        },
    })), (_a = {}, _a[constants_1.CLEAR_VALIDATE_PARENTAL_PIN] = function (draftState, action) {
        var userProfileId = action.payload.userProfileId;
        if (ramda_1.isNil(draftState.data[userProfileId]) || ramda_1.isNil(userProfileId)) {
            return;
        }
        draftState.data[userProfileId].pinValidationResult = {};
        draftState.data[userProfileId].expiryDate = null;
    }, _a)), api_1.createApiInitialState({})),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map